import React from 'react';
import WizardSelectControlledComponent from 'components/v2/epd-wizard-inputs/WizardSelectControlled';
import { DoubleFieldGrid } from 'styles/v2/Styles.styled';
import useProperty from '../../hooks/useProperty';
import usePropertyPath from '../../hooks/usePropertyPath';
import useDataSource from '../../hooks/useDataSource';
import { formatOptionLabelWithUnit } from 'types/dynamic-forms/formatOptionLabelWithUnit';
import { reactSelectPropsForHtmlLabel } from 'util/reactSelectPropsForHtmlLabel';
import WizardNumberInputControlled from 'components/v2/epd-wizard-inputs/WizardNumberInputControlled';
import { TextButton } from 'components/v2/buttons';
import FontIcon from 'components/icons/FontIcon';

interface Props {
  addedMaterialProperties: any[];
  canBeDeleted: boolean;
  onDelete(): void;
}

const MaterialPropertiesListRendererEntry: React.FC<Props> = ({
  addedMaterialProperties,
  canBeDeleted,
  onDelete,
}) => {
  const unitPath = usePropertyPath('unit');
  const unit = useProperty(unitPath);

  const valuePath = usePropertyPath('value');
  const value = useProperty(valuePath);

  const unitOptions = useDataSource(unitPath).options;
  const processedUnitOptions = unitOptions.map((option) => ({
    value: option.value,
    label: formatOptionLabelWithUnit(option, option.label).label,
    isDisabled: addedMaterialProperties.some((item) => item.unit === option.value && item.unit !== unit.value),
  }));

  return (
    <DoubleFieldGrid>
      <WizardSelectControlledComponent
        name="unit"
        options={processedUnitOptions}
        value={processedUnitOptions.find((o) => o.value === unit.value)}
        label="Unit"
        required
        onChanged={(_: string, newValue: any) => unit.setValue(newValue)}
        error={unit.errorMessage}
        disabled={unit.isDisabled}
        {...reactSelectPropsForHtmlLabel}
      />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '0.5rem' }}>
        <WizardNumberInputControlled
          name="value"
          label="Value"
          required
          value={value.value}
          onChange={(_, newValue) => value.setValue(newValue)}
          error={value.errorMessage}
          disabled={value.isDisabled}
          maxFractionDigits={7}
        />
        {!value.isDisabled && canBeDeleted && (
          <TextButton
            style={{ alignSelf: 'flex-end', margin: '0.25rem' }}
            type="button"
            text
            icon={<FontIcon icon="delete" />}
            onClick={onDelete}
          />
        )}
      </div>
    </DoubleFieldGrid>
  );
};

export default MaterialPropertiesListRendererEntry;
